<template>
  <div class="home">
    <div class="leftBatMenu">
      <button :class="{ active: active === 1 }" @click="pushPage(1, 'activitySelect')">
        展览预约
      </button>
      <button :class="{ active: active === 2 }" @click="pushPage(2, 'mine')">
        我的
      </button>
    </div>
    <div class="rightContent">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      carousl: {
        autoplay: false,
        indicator: "none",
      },
      active: 1,
      img: "https://ss3.bdstatic.com/70cFv8Sh_Q1YnxGkpoWK1HF6hhy/it/u=1635854645,849099520&fm=26&gp=0.jpg",
    };
  },
  methods: {
    pushPage: function (active, page) {
      this.active = active;
      this.$router.push(page);
    },
  },
  created () {
  },
  mounted () {
    this.$store.commit("updateAccountInfo", JSON.parse(sessionStorage.getItem('userInfo')));
  },
};
</script>
<style lang="less" scoped>
.home {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  width: 96%;
  margin: 0 auto;
  flex-direction: row;
  margin-top: 5vh;
  .leftBatMenu {
    width: 6%;
    button {
      width: 100%;
      background-color: white;
      color: #ae0c2a;
      border: none;
      height: 3.5vh;
      margin-bottom: 1.5vh;
      font-size: 12px;
      outline: none;
      border-radius: 2px;
    }
    .active {
      background-color: #ae0c2a;
      color: white;
    }
  }
  .rightContent {
    width: 78%;
    margin-left: 4%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/single/home.vue